export const init = section => {
  const tabs = [...section.querySelectorAll('.js-tab')];
  const contents = [...section.querySelectorAll('.js-tab-content')];

  tabs.forEach(tab => {
    if (window.innerWidth < 1024) {
      const mobContent = tab.querySelector('.js-tab-content-mobile');

      const height = {
        opened: null,
        closed: tab.offsetHeight,
      };

      mobContent.classList.remove('hidden');
      height.opened = tab.offsetHeight;
      tab.style.height = `${height.closed}px`;
      tab.classList.remove('active');

      tab.addEventListener('click', () => {
        if (tab.matches('.active')) {
          tab.style.height = `${height.closed}px`;
        } else {
          tab.style.height = `${height.opened}px`;
        }

        tab.classList.toggle('active');
      });
    } else {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));
        tab.classList.add('active');
        const activeTab = tab.getAttribute('data-tab');
        const activeContent = contents.find(
          content => content.getAttribute('data-tab') === activeTab,
        );
        activeContent.classList.add('active');
      });
    }
  });
};
